import { useMemo, useSyncExternalStore } from "react";
import {
  getApiMonitorSnapshot,
  subscribeToApiMonitor,
} from "../services/api";

const useApiRequestMonitor = (selector = (snapshot) => snapshot) => {
  const snapshot = useSyncExternalStore(
    subscribeToApiMonitor,
    getApiMonitorSnapshot,
    getApiMonitorSnapshot,
  );

  return useMemo(() => selector(snapshot), [selector, snapshot]);
};

export default useApiRequestMonitor;
